var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 19,
  fill: "none",
  viewBox: "0 0 22 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6D00",
  d: "M0 19 11 0l11 19zm3.45-2h15.1L11 4zM11 16q.424 0 .713-.287A.97.97 0 0 0 12 15a.97.97 0 0 0-.287-.713A.97.97 0 0 0 11 14a.97.97 0 0 0-.713.287A.97.97 0 0 0 10 15q0 .424.287.713.288.287.713.287m-1-3h2V8h-2z"
})));
export default SvgWarning;